import React from 'react';
import { SignUp } from '@clerk/react';
import { Link } from 'react-router-dom';
import { LogoFull } from '../components/Logo';

const G = '#004D35';
const BORDER = '#e8e5e0';
const BG = '#f5f3ef';

const SignUpPage = () => {
  return (
    <div style={{ minHeight: '100vh', background: BG }}>
      <nav style={{
        background: '#fff',
        borderBottom: `1px solid ${BORDER}`,
        padding: '0 40px',
        height: 56,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'sticky',
        top: 0,
        zIndex: 50,
      }}>
        <Link to="/" style={{ textDecoration: 'none' }}>
          <LogoFull size={26} />
        </Link>
        <Link
          to="/get-started"
          style={{ fontSize: 13, fontFamily: 'sans-serif', color: '#aaa', textDecoration: 'none' }}
          onMouseEnter={e => e.target.style.color = '#555'}
          onMouseLeave={e => e.target.style.color = '#aaa'}
        >
          ← Back
        </Link>
      </nav>

      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 56px)',
        padding: '40px 24px',
      }}>
        <div style={{ width: '100%', maxWidth: 480 }}>
          <div style={{ marginBottom: 24, textAlign: 'center' }}>
            <LogoFull size={28} />
          </div>
          <SignUp
            routing="path"
            path="/sign-up"
            signInUrl="/sign-in"
            fallbackRedirectUrl="/onboarding"
            appearance={{
              variables: {
                colorPrimary: G,
                colorPrimaryForeground: '#ffffff',
                borderRadius: '12px',
                fontFamily: 'sans-serif',
              },
              elements: {
                card: {
                  boxShadow: '0 8px 40px rgba(0,0,0,0.08)',
                  border: `1px solid ${BORDER}`,
                  borderRadius: 20,
                },
                headerTitle: { fontFamily: 'Georgia, serif', color: '#0a1a0f' },
                formButtonPrimary: {
                  background: G,
                  borderRadius: 999,
                  fontWeight: 700,
                },
                footerActionLink: { color: G },
              },
            }}
          />
          <p style={{
            textAlign: 'center',
            marginTop: 20,
            fontSize: 13,
            fontFamily: 'sans-serif',
            color: '#aaa',
          }}>
            Already have an account?{' '}
            <Link to="/login" style={{ color: G, fontWeight: 600, textDecoration: 'none' }}>
              Sign in →
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignUpPage;
